import React, { useState } from 'react';
import { useClientAuthStore } from '@/store/useClientAuthStore';
import { Link, useNavigate } from 'react-router-dom';

const LoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const login = useClientAuthStore((state) => state.login);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await login(email, password);
      navigate('/home');
    } catch (err: any) {
      setError('Email o contraseña incorrectos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#ECF0F1' }}>
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-2xl shadow-xl">
        <div className="text-center">
          {/* Business Logo */}
          <div className="mx-auto w-20 h-20 rounded-full flex items-center justify-center mb-6 p-2" style={{ backgroundColor: '#FF6B35' }}>
            <img 
              src="/images/centro-automotriz-hlfrd-icon-1.ico" 
              alt="Centro Automotriz HLFRD"
              className="w-12 h-12 object-contain"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
          </div>
          
          <h2 className="text-3xl font-bold" style={{ color: '#2C3E50' }}>
            Centro Automotriz HLFRD
          </h2>
          <p className="mt-2 text-sm" style={{ color: '#34495E' }}>
            Portal de Clientes - Iniciar Sesión
          </p>
        </div>
        
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium mb-1" style={{ color: '#34495E' }}>
                Email
              </label>
              <input
                id="email"
                type="email"
                required
                className="w-full px-4 py-3 border-2 rounded-xl focus:outline-none focus:ring-2 transition-all duration-200"
                style={{ 
                  borderColor: '#ECF0F1',
                  color: '#2C3E50',
                  backgroundColor: '#FFFFFF'
                }}
                onFocus={(e) => (e.target as HTMLInputElement).style.borderColor = '#FF6B35'}
                onBlur={(e) => (e.target as HTMLInputElement).style.borderColor = '#ECF0F1'}
                placeholder="tu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="password" className="block text-sm font-medium mb-1" style={{ color: '#34495E' }}>
                Contraseña
              </label>
              <input
                id="password"
                type="password"
                required
                className="w-full px-4 py-3 border-2 rounded-xl focus:outline-none focus:ring-2 transition-all duration-200"
                style={{ 
                  borderColor: '#ECF0F1',
                  color: '#2C3E50',
                  backgroundColor: '#FFFFFF'
                }}
                onFocus={(e) => (e.target as HTMLInputElement).style.borderColor = '#FF6B35'}
                onBlur={(e) => (e.target as HTMLInputElement).style.borderColor = '#ECF0F1'}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {error && (
            <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded">
              <div className="text-red-700 text-sm">{error}</div>
            </div>
          )}

          <div className="text-center mb-4">
            <Link
              to="/forgot-password"
              className="text-sm font-medium hover:underline transition-colors duration-200"
              style={{ color: '#FF6B35' }}
              onMouseEnter={(e) => ((e.target as HTMLAnchorElement).style.color = '#FF8C69')}
              onMouseLeave={(e) => ((e.target as HTMLAnchorElement).style.color = '#FF6B35')}
            >
              ¿Olvidaste tu contraseña?
            </Link>
          </div>

          <div>
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 px-4 text-white font-semibold rounded-xl transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-4 disabled:opacity-50 disabled:transform-none"
              style={{ 
                backgroundColor: loading ? '#FF8C69' : '#FF6B35',
                boxShadow: '0 4px 15px rgba(255, 107, 53, 0.3)'
              }}
              onMouseEnter={(e) => !loading && ((e.target as HTMLButtonElement).style.backgroundColor = '#FF8C69')}
              onMouseLeave={(e) => !loading && ((e.target as HTMLButtonElement).style.backgroundColor = '#FF6B35')}
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Iniciando...
                </div>
              ) : 'Iniciar Sesión'}
            </button>
          </div>

          <div className="text-center pt-4 space-y-3">
            <p className="text-sm" style={{ color: '#34495E' }}>
              ¿No tienes cuenta?{' '}
              <Link
                to="/register"
                className="font-medium hover:underline transition-colors duration-200"
                style={{ color: '#FF6B35' }}
                onMouseEnter={(e) => ((e.target as HTMLAnchorElement).style.color = '#FF8C69')}
                onMouseLeave={(e) => ((e.target as HTMLAnchorElement).style.color = '#FF6B35')}
              >
                Regístrate aquí
              </Link>
            </p>

          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;